import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../api";

function PaymentSuccess() {
  const [status, setStatus] = useState("loading");
  const [order, setOrder] = useState(null);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const orderId = searchParams.get("orderId");

  useEffect(() => {
    if (!orderId) {
      setStatus("error");
      return;
    }

    api
      .post("verify", { orderId })
      .then((res) => {
        if (res.data?.status && res.data?.paytmStatus === "TXN_SUCCESS") {
          setStatus("success");
          setOrder(res.data.data);
        } else {
          setStatus("failed");
        }
      })
      .catch(() => setStatus("error"));
  }, [orderId]);

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        {status === "loading" && <h2>Verifying Payment...</h2>}

        {status === "success" && (
          <>
            <h2 style={styles.title}>Payment Successful 🎉</h2>
            <p style={styles.text}>Your payment has been completed.</p>

            <p style={styles.small}>
              <strong>Order ID:</strong> {order?.orderId}
            </p>
            <p style={styles.small}>
              <strong>Transaction ID:</strong> {order?.txnId}
            </p>
            <p style={styles.small}>
              <strong>Amount:</strong> ₹{order?.txnAmount}
            </p>

            <div style={styles.actions}>
              <button onClick={() => navigate("/")} style={styles.homeBtn}>
                Go Home
              </button>
            </div>
          </>
        )}

        {status === "failed" && (
          <>
            <h2 style={{ color: "orange" }}>Payment Failed</h2>
            <p>If amount was debited, it will be refunded automatically.</p>
          </>
        )}

        {status === "error" && (
          <>
            <h2 style={{ color: "red" }}>Invalid Payment</h2>
            <p>No valid order found.</p>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrapper: {
    minHeight: "50vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f9d893",
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "10px",
    boxShadow: "0 10px 20px rgba(0,0,0,0.1)",
    textAlign: "center",
    maxWidth: "420px",
    width: "100%",
  },
  title: {
    color: "#198754",
    marginBottom: "10px",
  },
  text: {
    color: "#555",
  },
  small: {
    fontSize: "14px",
    color: "#777",
    marginTop: "10px",
  },
  actions: {
    marginTop: "25px",
    display: "flex",
    justifyContent: "center",
  },
  homeBtn: {
    background: "#636e72",
    border: "none",
    padding: "10px 20px",
    borderRadius: "6px",
    color: "#fff",
    cursor: "pointer",
  },
};

export default PaymentSuccess;
